import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './details';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import OtherDetails from './otherDetails';
import Features from './feature';
import ImagesList from './images';
import EscrowAccount from './escrow';
import axios from 'axios';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null, // for new file (File object)
  fileName: '',
  remarks: '',
  filePath: '',
  isNew: true, // ✅ identify new file
  fullUrl: '', // ✅ for existing file preview
});
const PropertyMasterUpdate = () => {
  const apiService = new LeaseApiService();
  let navigate = useNavigate();
  const { currencyPrecision } = useCurrency();
  const userName = useSelector(getName);
  const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
  const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads
  const [activeFY, setActiveFY] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false]);
  const [loading, setloader] = useState(false);
  const [propertyType, setPropertyType] = useState([]);
  const [ownerShip, setOwnerShip] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [countriesList, setCountries] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [projectUse, setProjectUse] = useState([]);
  const [community, setCommunity] = useState([]);
  const [subCommunity, setSubCommunity] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [districtList, setdistrictList] = useState([]);
  const [retentionAc, setRetentionAc] = useState([]);
  const [wipAccount, setWipAccount] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [propertyCategory, setPropertyCategory] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const location = useLocation();
  const leaseData = location.state;

  const [transectionData, setTransectionData] = useState({
    propertyNo: '',
    propertyName: '',
    plotNo: '',
    plotSize: '',
    address: '',
    prefixReceipt: '',
    remarks: '',
    propertyDescription: '',
    internalRemarks: '',
    location: '',
    area: '',
    buildingNo: '',
    roadNo: '',
    longitude: '',
    postalCode: '',
    blockNo: '',
    facilities: '',
    latitude: '',
    refferedBy: '',
    agreementDate: '',
    furnitureDescription: '',
    municipalityNo: '',
    video: '',
    community: null,
    subCommunity: null,
    district: '',
    country: null,
    city: null,
    propertyType: null,
    ownerShip: null,
    projectStatus: null,
    propertyUse: null,
    category: null,
  });

  const [otherDetails, setOtherDetails] = useState({
    totalParking: '',
    retentionPerc: '',
    totalUnit: '',
    noOfFloor: '',
    sqftRate: '',
    BuildUpArea: '',
    contractor: '',
    subContractor: '',
    grossArea: '',
    agent: '',
    saleRevenue: '',
    subAgent: '',
    completionDate: '',
    developer: '',
    subDeveloper: '',
    devcontactPerson: '',
    subDevContactPerson: '',
    devContactNo: '',
    subDevContact: '',
    propertyEmail: '',
    accountantEmail: '',
    otherContactPerson: '',
    otherContactNo: '',
    nameContactNo: '',
    otherEmail: '',
    cardNo: '',
    bondNo: '',
    bondType: '',
    bondDate: '',
    retentionAcc: null,
    no: null,
    asAsOwner: false,
    name: null,
    city: null,
    propertyType: null,
    ownerShip: null,
    projectStatus: null,
    propertyUse: null,
    category: null,
  });

  const [escrowDetails, setEscrowDetails] = useState({
    accountCode: '',
    IbanNo: '',
    accountName: '',
    bankName: '',
    swiftCode: '',
    bankContactNo: '',
    bankAddress: '',
  });

  useEffect(() => {
    fetchDropdownData();
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
  }, []);
  const fetchDropdownData = async () => {
    try {
      setTableLoading(true);
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'PropertyType,ProjectStatus,Country,Community,Ownership,PropertyStatus,PropertyCategory,WIPAccount,RetentionAccount,OwnerName',
      );
      const res = await apiService.getApiParamater('PROPERTY_MULTIDROP', `?${params.toString()}`);
      setPropertyType(res?.data?.dropdowns?.PropertyType);
      setCommunity(res?.data?.dropdowns?.Community);
      setProjectStatus(res?.data?.dropdowns?.ProjectStatus);
      setProjectUse(res?.data?.dropdowns?.PropertyType);
      setOwnerShip(res?.data?.dropdowns?.Ownership);
      setCountries(res?.data?.dropdowns?.Country);
      setPropertyCategory(res?.data?.dropdowns?.PropertyCategory);
      setRetentionAc(res?.data?.dropdowns?.RetentionAccount);
      setWipAccount(res?.data?.dropdowns?.RetentionAccount);
      setOwnerList(res?.data?.dropdowns?.OwnerName);
      if (leaseData) {
        const unitres = await apiService.getApiParamater('GET_PROPERTY_BY_ID', `/${leaseData?.property_No}`);
        let unitData = unitres?.data?.result?.property;
        const propertyType = res?.data?.dropdowns?.PropertyType?.find((dep) => dep.text === unitData?.property_Type);
        const country = res?.data?.dropdowns?.Country?.find((dep) => dep.text === unitData?.country);
        const community = res?.data?.dropdowns?.Community?.find((dep) => dep.text === unitData?.community_Name);
        const ownerShip = res?.data?.dropdowns?.Ownership?.find((dep) => dep.text === unitData?.property_Class);
        const projectStatus = res?.data?.dropdowns?.ProjectStatus?.find((dep) => dep.text === unitData?.project_Status);
        const category = res?.data?.dropdowns?.PropertyCategory?.find((dep) => dep.text === unitData?.property_Category);
        const ownerNoRow = res?.data?.dropdowns?.OwnerName?.find((dep) => String(dep?.value) === String(unitData?.ownerNo));
        const ownerNameRow = res?.data?.dropdowns?.OwnerName?.find((dep) => dep?.text === unitData?.ownerName);

        let cityOptions = [];
        if (country?.text || unitData?.country) {
          const cityParams = new URLSearchParams();
          cityParams.append('DropdownFor', 'CitiesByCountry');
          cityParams.append('CascadValue', country?.text || unitData?.country);
          const cityres = await apiService.getApiParamater('PROPERTY_CASCAD', `?${cityParams.toString()}`);
          cityOptions = cityres?.data?.items || [];
          setCityList(cityOptions);
        }
        const city = cityOptions?.find((dep) => dep.text === unitData?.city);

        let subCommunityRow = null;
        if (community?.value) {
          const subParams = new URLSearchParams();
          subParams.append('DropdownFor', 'SubCommunitiesByCommunitino');
          subParams.append('CascadValue', community?.value);
          const subres = await apiService.getApiParamater('PROPERTY_CASCAD', `?${subParams.toString()}`);
          const subOptions = subres?.data?.items || [];
          setSubCommunity(subOptions);
          subCommunityRow = subOptions?.find((dep) => dep.text === unitData?.subCommunity_Name) || null;
        }

        const parseApiDate = (val) => {
          if (!val) return '';
          const d = new Date(val);
          return Number.isNaN(d.getTime()) ? '' : d;
        };

        setTransectionData({
          propertyNo: unitData?.property_No || '',
          propertyName: unitData?.description || '',
          plotNo: unitData?.plot_No || '',
          plotSize: unitData?.plot_Size || '',
          address: unitData?.address1 || '',
          prefixReceipt: '',
          remarks: unitData?.remarks || '',
          propertyDescription: unitData?.descriptionBI || '',
          internalRemarks: '',
          location: unitData?.location || '',
          facilities: unitData?.facilities || '',
          longitude: unitData?.longitude || '',
          latitude: unitData?.latitude || '',
          refferedBy: unitData?.referredBy || '',
          furnitureDescription: unitData?.descriptionBI || '',
          agreementDate: parseApiDate(unitData?.referredOn),
          video: unitData?.exp7 || '',
          community: community ? { label: community?.text, value: community } : null,
          subCommunity: subCommunityRow ? { label: subCommunityRow?.text, value: subCommunityRow } : null,
          district: unitData?.district != null && String(unitData.district).trim() !== '' ? String(unitData.district).trim() : '',
          country: country ? { label: country?.text, value: country } : null,
          city: city ? { label: city?.text, value: city } : null,
          propertyType: propertyType ? { label: propertyType?.text, value: propertyType } : null,
          ownerShip: ownerShip ? { label: ownerShip?.text, value: ownerShip } : null,
          projectStatus: projectStatus ? { label: projectStatus?.text, value: projectStatus } : null,
          category: category ? { label: category?.text, value: category } : null,
        });
        setOtherDetails({
          totalParking: unitData?.total_Parking || '',
          totalUnit: unitData?.total_Units || '',
          noOfFloor: unitData?.floors || '',
          sqftRate: unitData?.rate_Sqft || '',
          BuildUpArea: unitData?.built_Area || '',
          contractor: unitData?.contractor || '',
          subContractor: unitData?.subContractor || '',
          grossArea: unitData?.gross_Area || '',
          agent: unitData?.agent || '',
          subAgent: unitData?.subAgent || '',
          developer: unitData?.developer || '',
          subDeveloper: unitData?.subDeveloper || '',
          devcontactPerson: unitData?.dContactPerson || '',
          subDevContactPerson: unitData?.sdContactPerson || '',
          devContactNo: unitData?.dContactNo || '',
          subDevContact: unitData?.sdContactNo || '',
          propertyEmail: unitData?.dEmail || '',
          accountantEmail: unitData?.sdEmail || '',
          otherContactPerson: unitData?.contact_Person || '',
          otherContactNo: unitData?.ownerContactNo || '',
          otherEmail: unitData?.ownerEmail || '',
          cardNo: unitData?.cardNumber || '',
          bondNo: unitData?.bondNumber || '',
          bondType: unitData?.bondType || '',
          bondDate: parseApiDate(unitData?.bondDate),
          retentionAcc: null,
          no: ownerNoRow ? { label: ownerNoRow?.value, value: ownerNoRow } : null,
          asAsOwner: false,
          name: ownerNameRow ? { label: ownerNameRow?.text, value: ownerNameRow } : null,
        });
        setEscrowDetails({
          accountName: unitData?.escrow_BankAcc || '',
          bankName: unitData?.escrow_Bank || '',
        });
        const fileparams = new URLSearchParams();
        fileparams.append('refNo', leaseData?.property_No);
        fileparams.append('fileCategory', 'Images');
        const imgRes = await apiService.getApiParamater('GET_FILE', `?${fileparams.toString()}`);
        if (imgRes?.data?.result) {
          const apiFiles = imgRes.data.result.map((item) => ({
            id: Date.now() + Math.random(),
            file: null,
            fileName: item.fileName,
            remarks: '',
            filePath: item?.filePath,
            isNew: false, // ✅ OLD FILE
            fullUrl: item.fullUrl, // ✅ for preview
          }));
          setAttachments([...apiFiles, createEmptyRow()]);
        }
      }
      setTableLoading(false);
    } catch (error) {
      setTableLoading(false);
      console.error('Error fetching dropdown data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleBackClick = () => {
    window.history.back();
  };
  const handleSave = async () => {
    try {
      setloader(true);
      const currentDatetimeUTC = new Date().toISOString();
      // Edit flow: do not block save on client validation; optional fields can be empty and are sent as "0".
      const today = new Date();
      let property = {
        property_No: transectionData?.propertyNo || '0',
        description: transectionData?.propertyName || '0',
        descriptionBI: transectionData?.furnitureDescription || '0',
        project: '0',
        location: transectionData?.location || '0',
        address1: transectionData?.address || '0',
        city: transectionData?.city?.label || '0',
        country: transectionData?.country?.label || '0',
        subDistrict: '0',
        district: (() => {
          const raw = transectionData?.district;
          const s = typeof raw === 'string' ? raw.trim() : raw?.label != null ? String(raw.label).trim() : '';
          return s || '0';
        })(),
        plot_No: transectionData?.plotNo || '0',
        subPlot_No: '0',
        plot_Size: transectionData?.plotSize || '0',
        community_No: transectionData?.community?.value?.value || '0',
        community_Name: transectionData?.community?.label || '0',
        subCommunity_No: transectionData?.subCommunity?.value?.value || '0',
        subCommunity_Name: transectionData?.subCommunity?.label || '0',
        contact_Person: '0',
        contact_No: '0',
        rate_Sqft: otherDetails?.sqftRate || '0',
        developer: otherDetails?.developer || '0',
        dContactNo: otherDetails?.devContactNo || '0',
        dEmail: otherDetails?.propertyEmail || '0',
        dContactPerson: otherDetails?.devcontactPerson || '0',
        subDeveloper: otherDetails?.subDeveloper || '0',
        sdContactNo: otherDetails?.subDevContact || '0',
        sdEmail: otherDetails?.accountantEmail || '0',
        sdContactPerson: otherDetails?.subDevContactPerson || '0',
        agent: otherDetails?.agent || '0',
        subAgent: otherDetails?.subAgent || '0',
        contractor: otherDetails?.contractor || '0',
        subContractor: otherDetails?.subContractor || '0',
        total_Units: otherDetails?.totalUnit || '0',
        total_Parking: '0',
        floors: otherDetails?.noOfFloor || '0',
        built_Area: '0',
        gross_Area: otherDetails?.grossArea || '0',
        property_Type: transectionData?.propertyType?.label || '0',
        property_Category: transectionData?.category?.label || '0',
        property_Class: transectionData?.ownerShip?.label || '0',
        start_Date: '2026-05-04T17:22:52.606Z',
        end_Date: '2026-05-04T17:22:52.606Z',
        project_Cost: '0',
        project_Status: transectionData?.projectStatus?.label || '0',
        facilities: transectionData?.facilities || '0',
        remarks: transectionData?.remarks || '0',
        escrow_Bank: escrowDetails?.bankName || '0',
        escrow_BankAcc: escrowDetails?.accountCode || '0',
        latitude: transectionData?.latitude || '0',
        longitude: transectionData?.longitude || '0',
        image_Filename: '0',
        ownerNo: otherDetails?.no?.label || '0',
        ownerName: otherDetails?.name?.label || '0',
        ownerContactNo: otherDetails?.otherContactNo || '0',
        ownerEmail: otherDetails?.otherEmail || '0',
        referredBy: '0',
        referredOn: transectionData?.agreementDate,
        exp1: '0',
        exp2: '0',
        exp3: '0',
        exp4: '0',
        exp5: '0',
        exp6: '0',
        cardNumber: otherDetails?.cardNo || '0',
        bondNumber: otherDetails?.bondNo || '0',
        bondType: otherDetails?.bondType || '0',
        bondDate: otherDetails?.bondDate,
        exp7: transectionData?.video || '0',
        exp8: '0',
        exp9: '0',
        exp10: '0',
        exp11: '0',
        exp12: '0',
        modifiedBy: '0',
        modifiedOn: today,
        createdBy: '0',
        createdOn: today,
      };
      const body = {
        propertyMain: {
          property: property,
          images: [
            {
              recordId: '0',
              ref_No: '0',
              image_Description: '0',
              image_Filename: '0',
              isDefault: true,
              folder: '0',
              url: '0',
              exp1: '0',
              exp2: '0',
              exp3: '0',
              createdBy: '0',
              createdOn: today,
              modifiedBy: '0',
              modifiedOn: today,
              isTemp: true,
              imagePath: '0',
            },
          ],
          isEdit: true,
        },
      };

      const postRes = await apiService.put('UPDATE_PROPERTY', body);
      if (postRes?.data?.statusCode === 200) {
        if (attachments) {
          handleUpload(postRes?.data?.result?.propertyNo);
        }
        toast.success(postRes?.data?.message);
        setloader(false);
        navigate('/Customer/Property/Master/Property/listing');
      } else {
        toast.warning(`${postRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      setloader(false);
    } finally {
      setloader(false);
    }
  };

  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);
    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    formData.append('refNo', leaseData?.property_No);
    formData.append('fileCategory', 'Images');

    // ✅ DEBUG
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post('https://pmkleaseapi.apps.pro360erp.com/api/FileUpload/unit-files', formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });

    console.log(response);
  };

  return (
    <div className="p-3">
      <div className="border-box2 p-2 d-flex justify-content-between" style={{ borderRadius: '8px' }}>
        <div className="">
          <h6>Update Property Master</h6>
        </div>
        <div className="d-flex gap-3">
          {loading === true ? (
            <div className="mainbtn flex-end gap-2">
              <ClipLoader color="#ffffff" className="mt-1" size={25} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2" onClick={handleSave}>
              <FaSave color="#fff" className="center mt-1 mx-2" />
              <div className="center">Save</div>
            </div>
          )}
          <div className="mainbtnSecondary flex-end gap-2" onClick={handleBackClick}>
            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
            <div className="center">Back</div>
          </div>
        </div>
      </div>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            Details
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
            Other Details
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
            Features
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            Images
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 4 ? 'sideActive' : ''}`} onClick={() => handleTabClick(4)}>
            Escrow Accounts
          </div>
        </div>
      </div>
      {/* Lease Details */}
      {gridVisibility[0] && (
        <PersonalDetails
          tableLoading={tableLoading}
          propertyType={propertyType}
          ownerShip={ownerShip}
          setTransectionData={setTransectionData}
          setSubCommunity={setSubCommunity}
          rowData={rowData}
          projectUse={projectUse}
          community={community}
          subCommunity={subCommunity}
          transectionData={transectionData}
          projectStatus={projectStatus}
          cityList={cityList}
          propertyCategory={propertyCategory}
          countriesList={countriesList}
          setCityList={setCityList}
          districtList={districtList}
        />
      )}
      {gridVisibility[1] && (
        <OtherDetails
          tableLoading={tableLoading}
          setTransectionData={setOtherDetails}
          rowData={rowData}
          wipAccount={wipAccount}
          transectionData={otherDetails}
          ownerList={ownerList}
        />
      )}
      {gridVisibility[2] && <Features />}
      {gridVisibility[3] && <ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />}
      {gridVisibility[4] && <EscrowAccount setTransectionData={setEscrowDetails} transectionData={escrowDetails} />}
    </div>
  );
};
export default PropertyMasterUpdate;
